<template>

<div style="position: relative">

<div class="mt-5"></div>

  <!-- list of bus routes -->
  <transition-group name="fade-slidex">
    <div v-for="(item, index) in routesDataFiltered"
       class="list-item mb-3"
       :key="'item-'+index"
       @click="selectRouteFromList(item.field_mode, item.title, item.field_gtfs_id, item.field_route_name)">
      <i class="icon-icon-bus" v-if="item.field_mode === 'Bus'"></i>
      <i class="icon-icon-light-rail" v-if="item.field_mode === 'Light Rail'"></i>
      <span
        class="circle-route-name"
        :title="item.title + ' - ' + item.field_route_name"
        :style="{ 'background-color': item.color,  'color': (item.color === '#29588C' || item.color === '#E4002B') ? '#fff' : '#000' }">{{ item.field_route_name }}</span>
      <span class="route-name" v-if="!isFuture">{{ item.field_old_endpoint.join(" - ") }}</span>
      <span class="route-name" v-if="isFuture">{{ item.field_new_endpoint.join(" - ") }}</span>
      <!-- <span v-if="item.field_status.indexOf('New') > -1" style="color:red">NEW! Coming soon</span> -->
    </div>
  </transition-group>

</div>

</template>

<script>
import mixinCommon from '../mixins/common'

export default {
  name: 'routes-list',
  props: ['routesData', 'isFuture'],
  mixins: [mixinCommon],
  data () {
    return {
    }
  },
  computed: {
    routesDataFiltered () {
      let result = {}
      for (let route in this.routesData) {
        if ((!this.isFuture && (this.routesData[route].field_status.indexOf('Old') > -1 || this.routesData[route].field_status.indexOf('Both') > -1))
          || (this.isFuture &&  this.routesData[route].field_status.indexOf('New') > -1)) {
          result[route] = this.routesData[route]
        }
        if (result[route]) {
          if (this.isFuture && this.routesData[route].field_new_route_color){
            result[route].color = this.routesData[route].field_new_route_color;
          } else if (!this.isFuture && this.routesData[route].field_old_route_color){
            result[route].color = this.routesData[route].field_old_route_color;
          }
        }
      }
      return result;
    }
  },
  methods: {
    selectRouteFromList (mode, routeNo, routeId, routeName) {
      console.log("TCL: selectRouteFromList -> mode, routeNo, routeId", mode, routeNo, routeId)
      routeNo = routeNo || '-'
      if (mode === 'Light Rail') {
        routeNo = routeName.split(" ").join("-").toLowerCase()
      }
      location.href = ((this.$route.path.substr(0,3) === '/es') ? '/es' : '') + '/routes/' + routeNo
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../sass/_variables.scss';

hr {
  border-top: 3px solid rgba(0,0,0,.15);
}

.tabs-current-options a,
.tabs-current-options .nav-tabs .nav-item.show .nav-link,
.tabs-current-options .nav-tabs .nav-link.active {
  color: #fff;
  border:none;
  background: none;
  cursor: pointer;
  // padding-left: 40px;
  // padding-right: 40px;
}


.tabs-current-options .active,
.tabs-current-options .nav-tabs .nav-item.show .nav-link,
.tabs-current-options .nav-tabs .nav-link.active {
  // border:none;
  // background: none;
  border-bottom: solid 1px #fff;
}

.tabs-current-options {
  // margin-left: -40px;
  // margin-right: -40px;
}
.tabs-current-options li {
  width: 50%;
}
.tabs-current-options .nav-tabs {
  border:none;
}

.icon-icon-bus, .icon-icon-light-rail {
  font-size:32px;
  min-width: 32px;
  display: inline-flex;
  vertical-align: middle;
  margin-left: 8px;
  margin-right: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/RoutesList.vue